import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { CONTACT } from "@/constants/testIds";
import { toast } from "sonner";
import { Mail, Phone, MessageCircle, Instagram, CheckCircle2 } from "lucide-react";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [ok, setOk] = useState(false);
  const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", f); setOk(true); toast.success("Message sent."); }
    catch { toast.error("Failed to send"); }
  };
  return (
    <div className="text-white max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-2 gap-12">
      <div>
        <p className="uppercase text-xs tracking-[0.3em] text-[#00B5D8] mb-3">Contact</p>
        <h1 className="font-display text-5xl md:text-6xl">Talk to Preshh.</h1>
        <p className="mt-6 text-white/70">For product enquiries, professional partnerships, press or support — we're here.</p>
        <div className="mt-8 space-y-4 text-white/80">
          <div className="flex items-center gap-3"><Mail size={18} className="text-[#00B5D8]" /> <a href="mailto:support@preshh.com.br" className="hover:text-[#00B5D8] transition-colors">support@preshh.com.br</a></div>
          <div className="flex items-center gap-3"><Phone size={18} className="text-[#00B5D8]" /> <a href="tel:+351935651544" className="hover:text-[#00B5D8] transition-colors">+351 935 651 544</a></div>
          <div className="flex items-center gap-3"><MessageCircle size={18} className="text-[#00B5D8]" /> WhatsApp business support</div>
          <div className="flex items-center gap-3"><Instagram size={18} className="text-[#00B5D8]" /> <a href="https://instagram.com/preshh.pt" target="_blank" rel="noopener noreferrer" className="hover:text-[#00B5D8] transition-colors">@preshh.pt</a></div>
        </div>
      </div>
      <form data-testid={CONTACT.form} onSubmit={submit} className="bg-[#111] border border-white/10 rounded-3xl p-6 md:p-8 space-y-4">
        {ok ? (
          <div className="py-12 text-center">
            <CheckCircle2 size={44} className="text-[#00B5D8] mx-auto" />
            <p className="mt-4 font-display text-2xl">Thank you.</p>
            <p className="mt-2 text-white/60">We'll respond within 1 business day.</p>
          </div>
        ) : (
          <>
            <h2 className="font-display text-2xl">Send us a message</h2>
            <Input data-testid={CONTACT.name} placeholder="Your name" required value={f.name} onChange={upd("name")} className="bg-white/5 border-white/10" />
            <Input data-testid={CONTACT.email} type="email" placeholder="Email" required value={f.email} onChange={upd("email")} className="bg-white/5 border-white/10" />
            <Input data-testid={CONTACT.subject} placeholder="Subject" required value={f.subject} onChange={upd("subject")} className="bg-white/5 border-white/10" />
            <Textarea data-testid={CONTACT.message} placeholder="Your message" required value={f.message} onChange={upd("message")} className="bg-white/5 border-white/10 min-h-32" />
            <Button data-testid={CONTACT.submit} type="submit" className="w-full bg-[#00B5D8] hover:bg-[#009AB8] text-black font-bold rounded-full py-6">Send message</Button>
          </>
        )}
      </form>
    </div>
  );
}
